<template>
  <div id="app" v-bind:class="{'has-scroll': scrollPosition > 1}">
    <Header />
    <router-view/>
    <Footer />
    <div class="alert" role="alert" v-if="notice">
      <strong>{{ $t('cookieTitle') }}</strong>
      <span class="content">{{ $t('cookieContent') }}</span>
      <span class="close-btn" @click="closeNotice()">
        <svg role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>{{ $t('cookieClose') }}</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    components: {
      'Header': () => import(/* webpackChunkName: "Header" */'@/components/Header'),
      'Footer': () => import(/* webpackChunkName: "Footer" */'@/components/Footer')
    },
    data() {    
      return {        
        scrollPosition: 0
      };
    },
    created() {
      window.addEventListener('scroll', this.handleScroll)
      this.handleScroll();
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    computed: {
      notice () {
        return this.$store.getters.notice
      }
    },
    methods: {    
      closeNotice() {
        this.$store.commit('closeNotice')
      },
      handleScroll() {
        this.scrollPosition = window.scrollY;
      }
    }
  }
</script>

<style lang="scss">

#app {
  @apply bg-white text-dark;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*
    
  */
  .alert {
    @apply bg-purple text-white px-4 py-3 fixed w-full;
    border-top-right-radius: 40% 3%;
    border-top-left-radius: 40% 3%;
    bottom: 0px;
    z-index: 1000;

    strong {
      @apply text-xs tw-font-bold;
    }
    span {
      &.content {
        @apply block text-xs;
      }
      &.close-btn {
        @apply absolute top-0 bottom-0 right-0 px-4 py-3;

        svg {
          @apply fill-current h-6 w-6 text-white transition-colors;

          &:hover {
            @apply text-pink;
          }
        }
      }
    }
  }
}
</style>
